




























































import { Component, Prop, Vue } from 'vue-property-decorator'
import NavBarStore from '../stores/NavBar'
import MenuStore from '../stores/Menu'
import '../directives/directives'

@Component

export default class ComponentNavBar extends Vue {
  @Prop({ default: 0 })
  badge!: {}
  get enableRotas() {
    const enableRotas = []
    
    this.rotas.map((rota) => {
      if (rota.denied) {
        const isDeniedRota = this.roles.some(item => rota.denied.indexOf(item) !== -1)

        if (!isDeniedRota) enableRotas.push(rota)
      } else {
        enableRotas.push(rota)
      }
    })

    return enableRotas
  }

  get rotas() {
    return NavBarStore.getters.ROTAS
  }

  get roles() {
    return NavBarStore.getters.ROLES
  }

  get show() {
    return NavBarStore.getters.SHOW
  }

  get viewName() {
    return this.$route.name
  }

  mounted() {
  }

  toggleMenu() {
    MenuStore.commit('SHOW', true)
  }
}
